import { useCallback } from "react";

import { useProfile } from "../../authentication/state/profile";

export default function useHasRole() {
	const profile = useProfile();

	return useCallback((...roles) => roles.includes(profile?.permissions?.role), [profile?.permissions?.role]);
}
